import { useEffect } from 'react';

export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    const prev = document.title;
    const base = 'Unbeatable Loans';
    document.title = title.includes('Unbeatable')
      ? title
      : `${title} | ${base}`;

    let meta = document.querySelector('meta[name="description"]');
    if (description) {
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    return () => {
      document.title = prev;
    };
  }, [title, description]);
}
